import React from 'react';
import { useNavigate, useParams } from 'react-router';
import GeneratedContentLandingForm from './GeneratedContentLandingForm';

const GeneratedContentLandingPage = () => {
  const navigate = useNavigate();
  const { accountId, domainId } = useParams();

  return (
    <GeneratedContentLandingForm
      onSubmit={({ id }) => {
        navigate(`/accounts/${accountId}/domains/${domainId}/generatedContent/${id}`);
      }}
    />
  );
};

export default GeneratedContentLandingPage;
